import UserReviews from "view3/UserReviews.js";

import connectFunction from "redux/connectFunction";

function mapStateToProps(state) {
  return {
    categories: state.categories,
    alert: state.alert,
    user: state.user,
    attributes: state.attributes,
    language: state.language
  };
}

const UserReviewsContainer = connectFunction(mapStateToProps)(UserReviews);
export default UserReviewsContainer;
